import CatalogEditor from './CatalogEditor';

export default function Edit() { return <CatalogEditor kind="room" editing />; }
